<template>
	<v-template>
		<v-row>
			<v-col cols="12" class="display-1 text-center">
				Elija su plan Vessi
			</v-col>
		</v-row>
		<v-expand-transition>
			<v-row v-show="cargandoPlanes">
				<v-col cols="12" class="d-flex justify-center">
					<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
				</v-col>
				<v-col cols="12" class="text-center">
					Cargando planes...
				</v-col>
			</v-row>
		</v-expand-transition>
		<v-row v-show="!cargandoPlanes">
			<v-col cols="12" sm="6" md="3" v-for="plan in planes">
				<v-card class="d-flex flex-column pa-2" height="100%" elevation="0"
					:color="(planSeleccionado === plan) ? 'selected-light' : 'grey lighten-4'">
					<!-- Parte superior de contenido -->
					<v-sheet class="pa-1 mb-auto" color="transparent">
						<div class="d-flex justify-center" v-if="plan.urlAvatar">
							<v-img :src="plan.urlAvatar" max-height="170" contain eager transition="scale-transition" />
						</div>
						<div class="text-center">
							<div :class="['py-1', 'headline', 'font-weight-black', (planSeleccionado === plan) ? 'primary--text' : undefined]">
								{{ plan.nombre }}
							</div>
							<div class="subtitle-2">
								Incorporación
							</div>
							<div>
								$
								<span class="title font-weight-black">
									{{ formatearMoneda(plan.valorIncorporacion*cantidad, plan.monedaValorIncorporacion) }}
								</span> + IVA
							</div>
							<div v-if="plan.valorIncorporacionAnterior" class="text-caption">
								(antes
								<span class="text-decoration-line-through">
									$ {{ formatearMoneda(plan.valorIncorporacionAnterior*cantidad, plan.monedaValorIncorporacion) }} + IVA
								</span>)
							</div>
						</div>
						<div class="text-center py-1" v-if="mostrarDatosRenovacion(plan)">
							<div class="subtitle-2">
								{{ plan.nombreRenovacion }} {{ plan.periodicidadRenovacion }}
							</div>
							<div class="subtitle-1" v-if="plan.monedaValorRenovacion==='UF'">
								<span class="font-weight-black">
									{{ formatearMoneda(plan.valorRenovacion*cantidad, plan.monedaValorRenovacion) }}
								</span>
								UF + IVA
							</div>
							<div class="subtitle-1" v-else-if="plan.monedaValorRenovacion==='CLP'">
								$
								<span class="font-weight-black">
									{{ formatearMoneda(plan.valorRenovacion*cantidad, plan.monedaValorRenovacion) }}
								</span>
								+ IVA
							</div>
							<div class="subtitle-1" v-else>
								<span class="font-weight-black">
									{{ plan.valorRenovacion*cantidad }} {{ plan.monedaValorRenovacion }}
								</span>
								+ IVA
							</div>
						</div>
						<div class="text-center py-1">
								Para
								<span class="font-weight-black">
									{{ cantidad }}
								</span>
								{{ (cantidad === 1) ? plan.unidadCantidadSingular : plan.unidadCantidadPlural }}
						</div>
						<div class="py-1">
							<v-divider></v-divider>
						</div>
						<div class="py-1 text-left">
							<div v-for="caracteristica in plan.caracteristicas" class="body-2">
								<v-icon small color="green" left class="mr-0">
									check
								</v-icon>
								{{ caracteristica }}
							</div>
						</div>
					</v-sheet>
					<!-- Parte inferior de contenido -->
					<v-sheet class="pa-1 mt-1 text-center" color="transparent">
						<v-btn color="primary" block depressed @click="seleccionarPlan(plan)" :disabled="planSeleccionado === plan">
							<v-icon left>
								touch_app
							</v-icon>
							Seleccionar
						</v-btn>
					</v-sheet>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="d-flex justify-center pa-1 mb-auto">
				<v-sheet class="ma-3 pa-2 rounded-xl" color="grey lighten-3">
					<div class="text-center py-1">
						Cantidad
					</div>
					<div class="text-center py-1">
						<v-btn v-on:click.stop="sumarCantidad(-1)" :disabled="(cantidad === 1)" 
							color="primary" icon depressed>
							<v-icon>
								remove
							</v-icon>
						</v-btn>
						<span class="mx-2">
							{{ cantidad }}
						</span>
						<v-btn v-on:click.stop="sumarCantidad(+1)" color="primary" icon depressed>
							<v-icon>
								add
							</v-icon>
						</v-btn>
					</div>
				</v-sheet>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="text-center body-1">
				<v-icon color="primary">
					auto_awesome
				</v-icon>
				¿Necesita una configuración personalizada de productos?
				<a href="https://vessi.cl/#contacto">
					¡Le ayudamos!
				</a>
			</v-col>
		</v-row>
	</v-template>
</template>

<script>
import { API } from 'aws-amplify';
import numeral from 'numeral';
import * as config from '@/config';
import urlJoin from 'url-join';

let apiName = config.autocontratarApiName;

export default {
	data: () => ({
		cargandoPlanes: false,
		planes: [],
		planSeleccionado: undefined,
		cantidad: 1,
	}),
	methods: {
		mostrarDatosRenovacion: function(plan) {
			let hayValorRenovacion = !!plan.valorRenovacion;
			let codigoPlan = plan.codigo; // coberg 2023-06-14, ocultar datos si plan es anual
			let planEsAnual = /^.*ANUAL.*$/.test(codigoPlan);
			let mostrar = (hayValorRenovacion && !planEsAnual);
			return mostrar;
		},
		getPlanes: async function() {
			let vm = this;
			let pathCodigos = '/planes/lista';
			let pathDetalle = '/planes/detalle';
			let blankInit = { };
			vm.cargandoPlanes = true;
			let codigosPlanes;

			try {
				let response = await API.get(apiName, pathCodigos, blankInit);
				codigosPlanes = response.codigosPlanes;
			}
			catch(e) {
				vm.notificar('Error al leer planes. Intente recargar esta página.', 'error');
				vm.cargandoPlanes = false;
				return;
			}

			const llamadasParalelas = 5;
			let planes = [];
			while(codigosPlanes.length > 0) {
				let paqueteCodigos = codigosPlanes.splice(0, llamadasParalelas);
				let paquetePromesas = [];
				for(const codigo of paqueteCodigos) {
					const pathDetallePlan = urlJoin(pathDetalle, codigo);
					const promesa = API.get(apiName, pathDetallePlan, blankInit);
					paquetePromesas.push(promesa);
				}
				try {
					let paquetePlanes = (await Promise.all(paquetePromesas)).map(r => r.plan);
					Array.prototype.push.apply(planes, paquetePlanes);
				}
				catch (e) {
					vm.notificar(`Error al leer detalles de planes. Intente recargar esta página.`, 'error');
					vm.cargandoPlanes = false;
					return;
				}
			}

			vm.planes = planes;
			vm.cargandoPlanes = false;
		},
		formatearMoneda: function(cifra, moneda='CLP') {
			let formateado;
			if(moneda === 'UF') {
				formateado = numeral(cifra).format('0,0[.][0000]'); // Precaución con más de 4 decimales
			}
			else {
				// Asumir CLP
				formateado = numeral(cifra).format();
			}
			return formateado;
		},
		emitirDatos: function(cantidad, plan) {
			// Esta función se llama desde watches, NO obtener los datos
			// con vm.XXXX. Por ejemplo, si se llama desde el watch de 
			// cantidad, NO se asegura que cuando esta función se ejecute
			// vm.cantidad tenga el nuevo valor.
			let vm = this;
			let datos = {
				'plan': plan,
				'cantidad': cantidad,
			};
			let valido = (plan !== undefined);
			vm.$emit('datos', valido, datos);
		},
		seleccionarPlan: function(plan) {
			let vm = this;
			vm.planSeleccionado = plan;
		},
		sumarCantidad: function(delta) {
			let vm = this;
			let nuevaCantidad = vm.cantidad + delta;
			if(nuevaCantidad < 1) {
				return;
			}
			vm.cantidad = nuevaCantidad;
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
	},
	mounted: function() {
		let vm = this;
		vm.getPlanes();
	},
	watch: {
		planSeleccionado: function(newVal) {
			let vm = this;
			vm.emitirDatos(vm.cantidad, newVal);
		},
		cantidad: function(newVal) {
			let vm = this;
			vm.emitirDatos(newVal, vm.planSeleccionado);
		},
	}
};
</script>
